import { useQuery } from '@tanstack/react-query';
import {
  gqlClient,
  graphql,
  Notes_TagCategory,
  type QueryAdditionalOptions,
  queryClient,
  type UseQueryReturnType,
} from '@tyro/api';
import { peopleKeys } from '../keys';

// Reset tag is hardcoded on the backend and hidden from staff in the UI.
const RESET_TAG_ID = 3654;

const noteTags = graphql(/* GraphQL */ `
  query notes_tags($filter: Notes_TagFilter!) {
    notes_tags(filter: $filter) {
      id
      name
      description
      category
      tag_l1
      colour
      pbac {
        isSecured
      }
    }
  }
`);

const noteTagsQuery = () => ({
  queryKey: peopleKeys.notes.noteTags(),
  queryFn: async () => {
    const result = await gqlClient.request(noteTags, {
      filter: { categories: [Notes_TagCategory.Note] },
    });
    return {
      ...result,
      notes_tags: result.notes_tags.filter((tag) => tag.id !== RESET_TAG_ID),
    };
  },
});

export function getNoteTags() {
  return queryClient.fetchQuery(noteTagsQuery());
}

export function useNoteTags(
  additionalOptions?: Omit<QueryAdditionalOptions, 'academicNamespaceId'>,
) {
  return useQuery({
    ...noteTagsQuery(),
    select: ({ notes_tags }) => notes_tags,
    ...additionalOptions,
  });
}

export type ReturnTypeFromUseNoteTags = UseQueryReturnType<
  typeof useNoteTags
>[number];
